import React from 'react'
import {
  TextField,
  NumberField,
  TextInput,
  NullableBooleanInput,
  BooleanField,
} from 'react-admin'
import { Datagrid, List, Filter } from '../../custom'
import {
  currencyFieldOptions,
  booleanFieldOptions,
} from '../../util/component-options'
import { useLabel } from '../../../hooks'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
  {
    booleanFieldHeader: {
      textAlign: 'center',
    },
  },
)

const HourlyRatesFilter = props => {
  const label = useLabel(props)

  return (
    <Filter>
      <TextInput label={label('description', 'filter')} source='description_i_cont' />
      <TextInput label={label('customer', 'filter')} source='customer_name_i_cont' />
      <NullableBooleanInput label={label('is_active')} source='is_active_true' />
    </Filter>
  )
}

const HourlyRatesList = props => {
  const label = useLabel(props)
  const classes = useStyles(props)

  return (
    <List
      {...props}
      filters={<HourlyRatesFilter />}
      filterDefaultValues={{ is_active_true: true }}
    >
      <Datagrid>
        <TextField source='description' label={label('description')} />
        <TextField source='customer.name' sortBy='customer_name' label={label('customer')} />
        <NumberField source='regular_rate_in_dollars' label={label('regular_rate_in_dollars')} options={currencyFieldOptions} />
        <NumberField source='overtime_rate_in_dollars' label={label('overtime_rate_in_dollars')} options={currencyFieldOptions} />
        <NumberField source='doubletime_rate_in_dollars' label={label('doubletime_rate_in_dollars')} options={currencyFieldOptions} />
        <BooleanField {...booleanFieldOptions} source='is_active' label={label('is_active')} headerClassName={classes.booleanFieldHeader} />
      </Datagrid>
    </List>
  )
}

export default HourlyRatesList
